import axios from 'axios'
import { MessageBox, Message, Loading } from 'element-ui'
import { getToken,getIe8n } from '@/utils/auth'
import router from '@/router/index.js'
import store from '@/store'
import { TokenKey } from '@/utils/commonConstant'
// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  // timeout: 5000 * 10 // request timeout
  timeout: 1000 * 10 *10 *10 *10 *10 *10 *10 *10// *10 // request timeout
})

var loading = {};
/*开启遮罩*/
function startLoading(showLoadingTime,id) {
  showLoadingTime = showLoadingTime || "20"

  loading[id] = Loading.service({
    customClass: "axios-loading" + showLoadingTime,
    lock: true,
    text: getIe8n()==='zh'?'加载中……':'Loading...',
    spinner: 'el-icon-loading',
    background: 'rgba(0, 0, 0, 0.7)'
  })
}
/*关闭遮罩*/
function endLoading(id) {
  if (loading[id]) {
    loading[id].close();
    delete loading[id]
  }
}
// 请求拦截
service.interceptors.request.use(
  config => {
    if (getToken()) {
      config.headers['X-Access-Token'] = getToken()
    }
    if(getIe8n()){
      config.headers['Accept-Language'] = getIe8n()
    }
    if(!config.headers.headers ||!config.headers.headers.CloseLodaingMask){
      startLoading(config.showLoadingTime,config.url);//请求遮罩开
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截
service.interceptors.response.use(
  /**
     * Determine the request status by custom code
     * Here is just an example
     * You can also judge the status by HTTP Status Code
     */
  response => {
    // 下载文件的时候将请求头等信息返回
    if (response.headers['content-type'] &&
      (response.headers['content-type'].indexOf('application/vnd.ms-excel') > -1 ||
        response.headers['content-type'].indexOf('application/octet-stream') > -1
      )) {
      if (loading[response.config.url]) endLoading(response.config.url);//请求遮罩关
      return response
    } else if (response.headers['content-disposition']) {//临时代码解决导出报err
      if (loading[response.config.url]) endLoading(response.config.url);//请求遮罩关
      return response
    }
    // 非下载文件的情况下
    const res = response.data;
    if (loading[response.config.url]) endLoading(response.config.url);//请求遮罩关
    // if the custom code is not 20000, it is judged as an error.
    if (res.respCode == 0 || res.respCode == '0'|| res.ok) {
      return res
    } else if(res instanceof Blob){
        return res
    }else if (res.status == 503 || res.status == '503') {
      localStorage.setItem('num', localStorage.num)
      if (localStorage.num++ < 1) {
        Message({
          center: true,
          message: error.message,
          type: 'error',
          duration: 5 * 1000
        })
        store.dispatch('user/Logout')
      }
      if (loading[response.config.url]) endLoading(response.config.url);//请求遮罩关
      return false
    } else {
      if (loading[response.config.url]) endLoading(response.config.url);//请求遮罩关
      Message({
        center: true,
        message: res.message || 'Error',
        type: 'error',
        duration: 5 * 1000
      })

      // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
      if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
        // to re-login
        MessageBox.confirm('You have been logged out, you can cancel to stay on this page, or log in again', 'Confirm logout', {
          confirmButtonText: 'Re-Login',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {
          // store.dispatch('user/resetTok*en').then(() => {
          //     location.reload()
          // })
        })
      }
      return Promise.reject(new Error(res.message || 'Error'))
    }
  },
  error => {
    //console.log('err=== ' + error) // for debug
    if (error == 'Error: Request failed with status code 503') {
      router.push({
        path: '/login',
        query: {
          redirect: location.hostname
        }
      })
      // localStorage.setItem('num', localStorage.num)
      // if (localStorage.num++ < 1) {
        // Message({
        //   center: true,
        //   // message: error.message,
        //   message: '登录失效，请重新登录',
        //   type: 'error',
        //   duration: 5 * 1000
        // })
        store.dispatch('user/Logout')
      // }
      endLoading(response.config.url)
      return false
    } else if (error == 'Error: Request failed with status code 504') {
        alert('您的账号已在其他地方登录,请重新登录!');
        store.dispatch('user/Logout')
        endLoading(response.config.url)
        return false
    }else {
      Message({
        center: true,
        message: error.message,
        type: 'error',
        duration: 5 * 1000
      })
      setTimeout(function () { endLoading(response.config.url) }, 600)//请求遮罩关
      return Promise.reject(error)
    }
  }
)

export default service
